import React, { useMemo } from 'react'
import cn from 'clsx'
import styled from 'styled-components'
import BuyNowBookLaterIcon from 'components/Luxkit/Icons/custom/BuyNowBookLaterIcon'
import moment from 'moment'
import { DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import { OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_BED_BANK, OFFER_TYPE_HOTEL, OFFER_TYPE_LAST_MINUTE, OFFER_TYPE_TOUR } from 'constants/offer'
import IconDetail from 'components/Common/IconDetail'
import BodyText from 'components/Luxkit/Typography/BodyText'

const DateToolTipWrapper = styled.span`
  display: inline-flex;

  &.primary {
    color: ${({ theme }) => theme.palette.primary.normal};
  }

  &.urgent {
    color: ${({ theme }) => theme.palette.messaging.urgency.main};
  }
`

const TravelUntilText = styled(BodyText)`
  position: relative;
  display: inline-block;
`

interface Props {
  size: 'medium' | 'large'
  travelToDate: string;
  type: App.OfferType;
  isCruise?: boolean;
}

function FlashTourTravelUntilMessage(props: Props) {
  const { size, travelToDate, type, isCruise } = props

  const {
    bnblIconSize,
  } = useMemo(() => {
    switch (size) {
      case 'large':
        return {
          bnblIconSize: 25,
        }
      case 'medium':
        return {
          bnblIconSize: 18,
        }
    }
  }, [size])

  const tooltipColourClass = cn({
    primary: type === OFFER_TYPE_TOUR || type === OFFER_TYPE_HOTEL,
    urgent: type === OFFER_TYPE_ALWAYS_ON || type === OFFER_TYPE_BED_BANK || type === OFFER_TYPE_LAST_MINUTE,
  })

  return (
    <IconDetail weight="bold">
      <BuyNowBookLaterIcon size={bnblIconSize} />
      <TravelUntilText variant={size} weight="bold">
        {isCruise ? 'Departing from ' : 'Travel until '}
        <DateToolTipWrapper className={tooltipColourClass}>
          {moment(travelToDate).format(DMY_CASUAL_FORMAT)}
        </DateToolTipWrapper>
      </TravelUntilText>
    </IconDetail>
  )
}

FlashTourTravelUntilMessage.defaultProps = {
  size: 'md',
}

export default FlashTourTravelUntilMessage
